// --- Utility Function for Amount Formatting (Reusable) ---
export const formatAmountForDisplay = (amount) => {
  if (typeof amount === "string") {
    amount = parseFloat(amount);
  }
  if (isNaN(amount)) {
    return "0.00";
  }
  return amount.toLocaleString("en-NG", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatDate = (dateString) => {
  if (!dateString) return "--";
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  try {
    let date = new Date(dateString).toLocaleDateString(undefined, options);
    if (date === "Invalid Date") {
      return "--";
    } else {
      return date;
    }
  } catch (e) {
    console.error("Error formatting date:", e);
    return "--";
  }
};